import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';

export interface ListMeetings {
    token: string;
    stop?: boolean;
}

export const listMeetings = createAction<ActionType, ListMeetings>(
    ActionType.TC__TI__LIST_MEETINGS,
);
